export default __webpack_public_path__ + "e70412137b107095a4e5185072c8abbb.png";